import React , { useState,useEffect } from 'react';
import Tags from '../../components/Tags';
import AddTag from '../../components/AddTag';
import {GET_DISHTAGS} from '../../constants';

const TagsPage = ({ classes }) => { 
  return (
    <div className={`${classes.wrap} categories`}>
      <div className={classes.categories}>
        <Tags/>
      </div>
      <div className={classes.addCategories}>
        <AddTag/>
      </div>
    </div>
  );
};

export default TagsPage;
